
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.088 50.2a.712.712 0 000-.14V27.83a.9.9 0 000-.28l-3.51-12a4.45 4.45 0 001.39-3.55c0-2.27-1.11-4-2.59-4h-25.1c-1.48 0-2.59 1.72-2.59 4 0 2 .9 3.63 2.16 3.93l-2.84 11.21c-.01.083-.01.167 0 .25v22.72a1 1 0 001 1h31.14a1.09 1.09 0 00.39-.08 1 1 0 00.32-.22c.026-.035.049-.072.07-.11a.738.738 0 00.13-.21.86.86 0 00.03-.29zm-4.13-38.25a2.66 2.66 0 01-.59 2 2.66 2.66 0 01-.59-2 2.81 2.81 0 01.58-2 2.7 2.7 0 01.6 2zm-25.65-2h22.79a5.887 5.887 0 00-.32 2c-.01.68.098 1.357.32 2h-22.78a2.59 2.59 0 01-.63-2 2.63 2.63 0 01.62-1.99v-.01zm20.92 39.1h-22.25v-21.6l2.91-11.52h22.21l-2.84 11.65c-.01.08-.01.16 0 .24l-.03 21.23zm3.45-2.72l-1.45 1.44V28l2.23-9.13 2.66 9.15v19.75l-1.44-1.38v-17.4a1 1 0 00-2 0v17.34zm1 1.81l.95.91h-1.9l.95-.91z"}})])
          )
        }
      }
    